import axios from "axios";

export default function getShippingOrderMasterList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post("/distributor/admin/api/v1/shipping-order/master-list", {
        shipping_order_uuid: parameters.shipping_order_uuid,
        length: parameters.length,
        start: parameters.start,
        filter: {
          search: parameters.filter.search,
          search_column: parameters.filter.search_column,
          order_type: parameters.filter.order_type,
          products: parameters.filter.products,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
